import ErrorLogger from './ErrorLogger';
import InactivityHelper from './InactivityHelper';
import KeyboardHelper from './KeyboardHelper';
import { activityTyping, mapState, mapMutations, mapActions, mapGetters } from '../store/helpers';
import mixins from 'vue-typed-mixins';
export default mixins(ErrorLogger, InactivityHelper, KeyboardHelper).extend({
    computed: Object.assign(Object.assign({}, mapState(activityTyping, {
        attemptedKey: 'attemptedKey',
        typingProgress: 'progress'
    })), mapGetters(activityTyping, [
        'isTouchHold',
        'isEndOfCurrentText',
        'isEndOfCurrentWord',
        'isEndOfCurrentSentence',
        'isEndOfRound',
        'expectedKey'
    ])),
    // handleWrongKey is base method in ActivityManager. Activites implement handleCorrectKey.
    watch: {
        attemptedKey(attempt) {
            if (this.isActiveAssessment) {
                this.resetTimer();
            }
            if (attempt.character && !attempt.character.includes('shift')) {
                if (attempt.isCorrect) {
                    //@ts-ignore implemented by consumer
                    this.handleCorrectKey(attempt);
                    this.logCorrectCharacter(attempt.character);
                }
                else {
                    //@ts-ignore implemented by consumer
                    this.handleWrongKey(attempt);
                }
            }
        }
    },
    methods: Object.assign(Object.assign({}, mapMutations(activityTyping, ['incrementTypingIndex'])), mapActions(activityTyping, ['setupNewRound', 'setCurrentStep']))
});
